/* ══════════════════════════════════════════════════════════════════════
   THEME.JS — comportements. Écrit dès maintenant au format Shopify.

   Pourquoi cette architecture ?
   Dans l'éditeur de thème Shopify, le marchand ajoute, déplace et
   supprime des sections SANS recharger la page. Un script classique en
   DOMContentLoaded ne s'exécute qu'une fois : toute section ajoutée
   après coup reste morte, et le marchand croit que le thème est cassé.
   C'est le motif de rejet n°1 à la validation Theme Store.

   La solution : enregistrer chaque comportement par section, et
   réinitialiser sur les événements shopify:section:load / :unload.
   Ces événements n'existent pas en local — le code les ignore
   proprement — mais ils fonctionneront dès la conversion en Liquid,
   sans une ligne à réécrire.
   ══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── Réglages ────────────────────────────────────────────────────── */
  var SPLASH_MS = 1600;  // délai avant retrait du splash du DOM

  /* Transition pixellisée — règle le caractère de l'effet ici.
     PX_DUR doit correspondre à la durée écrite dans animations.css. */
  var PX_ROWS   = 8;     // lignes de la grille
  var PX_COLS   = 14;    // colonnes
  /* Sens du retrait. false : la vague continue de descendre, comme au
     recouvrement — un seul mouvement qui traverse la page. true : elle
     remonte par où elle est venue, comme un rideau qu'on relève.
     C'était true, et les deux phases se contredisaient : les cases se
     repliaient vers le bas pendant que les lignes s'effaçaient depuis le
     bas. Deux directions à la fois, donc aucune. */
  var PX_REMONTE = false;
  var PX_DUR    = 420;   // durée d'animation d'une cellule (ms)
  var PX_STEP   = 30;    // décalage entre deux lignes (ms)
  var PX_JITTER = 5;     // désordre : 0 = balayage net, 5 = pluie irrégulière

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Pont entre la section « wall » et la section « header » : le mur
     capte la souris, le nom de la marque doit suivre. Une variable de
     module plutôt qu'un global sur window — le thème ne doit rien
     exposer au reste de la page, un autre script pourrait l'écraser. */

  /* ══════════════════════════════════════════════════════════════════
     REGISTRE DE SECTIONS
     register('nom', function (root) { ... })
     `root` = l'élément [data-section="nom"]. Ne sors JAMAIS de root
     avec un document.querySelector global : si la section est présente
     deux fois, tu ne câbleras que la première.
     ══════════════════════════════════════════════════════════════════ */
  /* Posée par le module du tiroir, appelée par l'ajout au panier. */
  var ouvrirPanier = function () {};

  var registry = {};
  var register = function (name, fn) { registry[name] = fn; };

  function initWithin(scope) {
    (scope || document).querySelectorAll('[data-section]').forEach(function (el) {
      var name = el.getAttribute('data-section');
      if (registry[name] && !el.__init) { el.__init = true; registry[name](el); }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initWithin(document); });

  // Éditeur Shopify — sans effet en local, actif après conversion
  document.addEventListener('shopify:section:load', function (e) {
    initWithin(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.__init = false;
  });


  /* ══════════════════════════════════════════════════════════════════
     CASES DÉPLIANTES — une seule mécanique pour tout le site
     Fiche produit, produit en vedette, questions fréquentes : un site
     n'a qu'une façon de replier de l'information. aria-expanded porte
     l'état pour les lecteurs d'écran, la classe .open ne sert qu'au
     dessin (c'est elle qui fait passer grid-template-rows de 0fr à 1fr).
     Les cases sont indépendantes : ouvrir l'une ne referme pas les
     autres — on compare souvent deux réponses côte à côte.
     ══════════════════════════════════════════════════════════════════ */
  function deplier(root) {
    root.querySelectorAll('.acc-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var ouvert = b.parentElement.classList.toggle('open');
        b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      });
    });
  }


  /* ══════════════════════════════════════════════════════════════════
     SECTION splash — déverrouillage au glissement
     ══════════════════════════════════════════════════════════════════ */
  register('splash', function (root) {
    var knob  = root.querySelector('.unlock-knob');
    var track = root.querySelector('.unlock-track');
    var fill  = root.querySelector('.unlock-fill');
    var wrap  = root.querySelector('.unlock');
    if (!knob) return;


    /* déverrouillage */
    var opened = false, dragging = false, startX = 0, max = 0;

    function open() {
      if (opened) return;
      opened = true;
      root.classList.add('is-open');
      document.body.classList.remove('is-locked');
      document.body.classList.add('is-revealed');
      setTimeout(function () { root.remove(); }, reduce ? 0 : SPLASH_MS);
    }
    function setPos(x) {
      var v = Math.max(0, Math.min(x, max));
      knob.style.transform = 'translateX(' + v + 'px)';
      fill.style.width = (v + 52) + 'px';
      return v;
    }

    knob.addEventListener('pointerdown', function (e) {
      dragging = true; startX = e.clientX;
      max = track.offsetWidth - 56;
      wrap.classList.add('is-dragging');
      knob.setPointerCapture(e.pointerId);
    });
    knob.addEventListener('pointermove', function (e) {
      if (dragging) setPos(e.clientX - startX);
    });
    knob.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      wrap.classList.remove('is-dragging');
      if (setPos(e.clientX - startX) > max * 0.62) { setPos(max); open(); }
      else { knob.style.transform = 'translateX(0)'; fill.style.width = '0'; }
    });
    knob.addEventListener('click', function () { if (!dragging) open(); });

    document.addEventListener('keydown', function (e) {
      if (!opened && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(); }
    });
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION announcement-bar — duplication pour boucle sans couture
     ══════════════════════════════════════════════════════════════════ */
  register('announcement-bar', function (root) {
    var row = root.querySelector('.ticker-row');
    if (row) row.innerHTML = row.innerHTML + row.innerHTML;
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION header — état collé au défilement
     ══════════════════════════════════════════════════════════════════ */
  register('header', function (root) {

    var body = document.body;

    /* ── Le nom, du hero jusque dans la barre ──────────────────────────
       Le grand nom du hero et celui de la barre sont le même mot.

       Ce n'est PAS une animation liée au défilement. On ne suit pas la
       molette image par image : on attend d'avoir franchi un seuil, puis
       le nom part d'un seul mouvement, à sa propre vitesse. C'est la
       différence entre « ça suit mon doigt » et « le site répond » — un
       geste net vaut mieux qu'un curseur.

       Deux seuils, pas un : on plonge à 70 px, on ne remonte qu'en
       repassant sous 12 px. Sans cet écart, un défilement hésitant
       autour d'un seuil unique ferait clignoter le nom.

       Le mouvement est un translate + scale, jamais une font-size
       animée : seul le compositeur travaille, rien ne se remet en page à
       chaque image. C'est là que se gagne la fluidité.

       La cible n'est pas devinée mais mesurée : le nom de la barre reste
       dans le flux (visibility, jamais display: none), donc son
       rectangle est lisible même invisible. Rien à recalculer à la main
       si les icônes, le menu ou la police changent. */
    var heroBrand = document.querySelector('.hero-brand');
    var hdrBrand  = root.querySelector('.brand');
    var dock      = function () {};

    /* Quand la barre cesse d'être transparente.

       Tant que la première section est à l'écran, la barre la laisse
       passer : fond transparent, contenu blanc. Elle ne devient blanche
       qu'au moment où le bas de cette section vient l'atteindre — pas un
       pixel avant, sinon on verrait une bande blanche mordre sur la
       photo. Le fondu entre les deux états est en CSS.

       Le seuil est mesuré une fois, pas à chaque défilement : lire une
       hauteur pendant qu'on défile force le navigateur à recalculer la
       mise en page au pire moment.

       Sans hero (page produit, collection…), on retombe sur le seuil de
       défilement ordinaire. */
    var hero    = document.querySelector('.hero');
    /* Sans hero — compte, produit, collection — la barre est pleine dès le
       premier pixel. Une barre transparente n'a de sens que posée sur une
       image : sur un fond blanc, elle laisse ses libellés flotter sans
       rien qui les rattache, puis se remplit d'un coup au premier
       défilement. Le filet du bas suffit à l'ancrer. */
    var solidAt = 0;

    function measureBar() {
      if (hero) solidAt = hero.offsetTop + hero.offsetHeight - root.offsetHeight;
    }

    function stuck() { root.classList.toggle('is-stuck', scrollY >= solidAt); }

    function onScroll() { dock(); stuck(); }

    if (heroBrand && hdrBrand) {
      var REST   = 'translate(-50%, -50%)';
      var DOCKED = REST;
      var docked = false;
      var timer  = 0;
      var DUR    = 700;                  // doit valoir la transition CSS

      /* En fixed, le nom ne dérive plus avec la page : il tient sa place
         à l'écran, et c'est nous qui décidons quand il la quitte. En
         absolu — JS coupé — il reste centré dans le hero : bon repli. */
      heroBrand.style.position = 'fixed';

      function end() {
        clearTimeout(timer);
        heroBrand.removeEventListener('transitionend', onEnd);
        heroBrand.classList.remove('is-flying');
        if (!docked) return;

        /* Passage de relais à l'arrivée seulement : le petit nom de la
           barre prend la place du grand, qui s'efface. Les deux se
           superposent alors au pixel près — l'échange ne se voit pas, et
           ce qui reste à l'écran est du vrai texte à sa taille, net
           plutôt qu'un rendu mis à l'échelle. */
        body.classList.add('brand-landed');
      }

      function onEnd(e) { if (e.propertyName === 'transform') end(); }

      function apply(instant) {
        clearTimeout(timer);
        heroBrand.removeEventListener('transitionend', onEnd);
        heroBrand.style.transform = docked ? DOCKED : REST;
        body.classList.toggle('brand-docked', docked);
        if (!docked) body.classList.remove('brand-landed');

        if (instant) { heroBrand.classList.remove('is-flying'); end(); return; }

        /* Le temps du vol seulement : le texte est promu sur son propre
           calque, rastérisé une fois, puis simplement déplacé. On le
           retire ensuite — un calque permanent sur du texte finit par le
           rendre mou. */
        heroBrand.classList.add('is-flying');

        /* On attend la fin réelle du mouvement, pas une durée au
           chronomètre. Une transition CSS ne démarre qu'à l'image
           suivante : un minuteur réglé sur la même durée expire donc
           toujours un cheveu trop tôt, et l'échange se ferait alors que
           le nom n'a pas fini son dernier dixième de pixel.
           Le minuteur reste en filet — transitionend ne se déclenche pas
           si la transition est interrompue ou n'est jamais partie. */
        heroBrand.addEventListener('transitionend', onEnd);
        timer = setTimeout(end, DUR + 150);
      }

      function matrix(dx, dy, s) {
        return REST + ' translate(' + dx.toFixed(3) + 'px, ' + dy.toFixed(3) +
               'px) scale(' + s.toFixed(6) + ')';
      }

      function measure() {
        heroBrand.style.transition = 'none';
        /* On mesure le nom tel qu'il sera EN VOL, pas tel qu'il est au
           repos : son ® prend la taille de celui de la barre dès que le
           voyage commence (voir base.css). Mesurer sans cette classe
           donnerait une largeur qui n'existe à aucun moment du trajet, et
           l'échelle calculée dessus raterait la cible. */
        heroBrand.classList.add('metrics-docked');
        heroBrand.style.transform  = REST;
        var from = heroBrand.getBoundingClientRect();
        /* On mesure le lien, pas le bloc qui le contient : c'est lui qui
           épouse le texte. Le bloc, lui, est étiré par la grille de la
           barre — viser son centre, c'est viser à côté. */
        var to   = (hdrBrand.firstElementChild || hdrBrand).getBoundingClientRect();

        /* L'échelle se prend sur les largeurs mesurées, pas sur le
           rapport des font-size : c'est la largeur finale qui doit tomber
           juste pour que l'échange ne se voie pas. */
        var s  = to.width / (from.width || 1);
        var dx = to.left + to.width  / 2 - (from.left + from.width  / 2);
        var dy = to.top  + to.height / 2 - (from.top  + from.height / 2);
        DOCKED = matrix(dx, dy, s);

        /* Puis on vérifie au lieu de croire.

           Le calcul ci-dessus suppose que le navigateur place le texte
           exactement là où la géométrie le prévoit. Il s'en approche, sans
           jamais y être : demi-interlignes négatifs, arrondis de sous-pixel,
           boîte du lien en inline-flex — chacun ajoute sa fraction, et la
           somme se voit à l'atterrissage.

           Alors on pose la transformation, on relit la position obtenue, et
           on corrige l'écart. C'est une boucle fermée : peu importe d'où
           vient l'erreur, elle est mesurée puis annulée. Deux passes
           suffisent — la seconde ne corrige déjà plus qu'un centième de
           pixel. Le coût est de deux relectures au chargement, jamais
           pendant le défilement. */
        for (var pass = 0; pass < 2; pass++) {
          heroBrand.style.transform = DOCKED;
          var got = heroBrand.getBoundingClientRect();
          if (!got.width) break;
          s  *= to.width / got.width;
          dx += (to.left + to.width  / 2) - (got.left + got.width  / 2);
          dy += (to.top  + to.height / 2) - (got.top  + got.height / 2);
          DOCKED = matrix(dx, dy, s);
        }
        /* Ce qu'il reste après correction, en pixels. Zéro = les deux
           noms se superposent exactement. L'aperçu l'affiche dans le
           panneau de la touche P : une impression devient un chiffre. */
        heroBrand.style.transform = DOCKED;
        var last = heroBrand.getBoundingClientRect();
        window.__landing = {
          x: (to.left + to.width  / 2) - (last.left + last.width  / 2),
          y: (to.top  + to.height / 2) - (last.top  + last.height / 2),
          w: to.width - last.width
        };

        /* Toujours sans transition : au chargement comme au
           redimensionnement, le nom doit se trouver là où il doit être,
           pas y aller. Seul un franchissement de seuil se joue. */
        apply(true);
        heroBrand.classList.remove('metrics-docked');
        void heroBrand.offsetWidth;      // on referme avant de rendre la main
        heroBrand.style.transition = '';
      }

      dock = function () {
        var next = docked ? scrollY > 12 : scrollY > 70;
        if (next === docked) return;
        docked = next;
        apply(false);
      };

      /* Un rechargement en cours de page ne doit pas rejouer le voyage :
         on part de l'état que le défilement impose déjà. */
      docked = scrollY > 70;
      addEventListener('resize', measure, { passive: true });
      measure();
      /* Les polices arrivent parfois après la mesure : la largeur de
         départ change alors sans que rien n'ait défilé. */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    }

    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', function () { measureBar(); onScroll(); },
                     { passive: true });
    /* La photo du hero peut arriver après le script : sa hauteur est déjà
       fixée par min-height, mais on remesure une fois tout chargé plutôt
       que de parier dessus. */
    addEventListener('load', function () { measureBar(); onScroll(); });
    measureBar();
    onScroll();

    /* ── Menu déroulant ──────────────────────────────────────────────
       Le JS ne fait que trois choses : découper le texte en lettres,
       basculer une classe, et changer l'image d'aperçu. Tout le
       mouvement est en CSS — d'où l'absence totale de librairie. */
    var menu = document.querySelector('.menu');
    if (!menu) return;

    /* 1. Découpe chaque lien en lettres et numérote-les.
          --i sert au transition-delay calculé dans animations.css.
          aria-label conserve le mot entier pour les lecteurs d'écran,
          qui sinon épelleraient « H-O-M-E » lettre par lettre. */
    var i = 0;
    menu.querySelectorAll('.menu-link').forEach(function (link) {
      var text = link.textContent.trim();
      link.setAttribute('aria-label', text);
      link.textContent = '';
      text.split('').forEach(function (c) {
        var span = document.createElement('span');
        span.className = 'ch';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = c === ' ' ? ' ' : c;
        span.style.setProperty('--i', i++);
        link.appendChild(span);
      });
    });
    menu.querySelectorAll('.menu-foot li').forEach(function (li, n) {
      var span = document.createElement('span');
      span.innerHTML = li.innerHTML;
      span.style.setProperty('--i', i + n * 2);
      li.textContent = '';
      li.appendChild(span);
    });

    /* 2. Ouverture / fermeture */
    var open = false;
    function setOpen(v) {
      open = v;
      document.body.classList.toggle('menu-open', v);
      root.querySelectorAll('[data-menu-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', v ? 'true' : 'false');
      });
      menu.setAttribute('aria-hidden', v ? 'false' : 'true');
    }
    root.querySelectorAll('[data-menu-toggle]').forEach(function (b) {
      b.setAttribute('aria-controls', 'site-menu');
      b.addEventListener('click', function (e) {
        e.preventDefault();       // le logo est un déclencheur, pas un lien
        setOpen(!open);
      });
    });
    document.querySelector('.panel-bg').addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) setOpen(false);
    });
    /* refermer après un clic sur un lien : la transition pixellisée
       prend le relais pour la navigation */
    menu.addEventListener('click', function (e) {
      if (e.target.closest('.menu-link')) setOpen(false);
    });

    /* « Politiques » ne quitte pas la page : il descend au pied, où les
       liens de politiques vivent déjà. Un cinquième lien vers une page
       dédiée aurait dupliqué une liste que le bas de page tient à jour
       tout seul — et Shopify génère ces pages, le thème ne les écrit pas.

       Le href reste une vraie ancre (#pied) : sans JavaScript, le
       navigateur y saute quand même. Ici on remplace le saut par un
       défilement, et on le laisse commencer pendant que le panneau se
       relève : les deux mouvements se lisent comme un seul geste. Les
       enchaîner l'un après l'autre donnerait deux temps morts. */
    var doux = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    menu.addEventListener('click', function (e) {
      if (!e.target.closest('[data-vers-pied]')) return;
      e.preventDefault();
      var pied = document.querySelector('.pied');
      if (!pied) return;
      setTimeout(function () {
        pied.scrollIntoView({ behavior: doux ? 'smooth' : 'auto', block: 'end' });
      }, 220);
    });

    /* 3. Aperçu au survol — la seule chose que le CSS ne peut pas faire */
    var shots = menu.querySelectorAll('.menu-preview img');
    if (!shots.length) return;
    menu.querySelector('.menu-links').addEventListener('mouseover', function (e) {
      var link = e.target.closest('.menu-link');
      if (!link) return;
      var idx = link.dataset.preview;
      shots.forEach(function (img) {
        img.classList.toggle('is-on', img.dataset.preview === idx);
      });
    });
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION hero — mur vidéo incurvé
     ══════════════════════════════════════════════════════════════════
     Reprend la parabole de la démo Three.js (z = x² / k) mais en CSS 3D.
     Les positions sont calculées UNE fois ; ensuite seul le mur pivote
     avec la souris, via deux variables. Aucune boucle de rendu.

     Les vidéos ne sont posées que sur les tuiles centrales : chaque
     élément <video> mobilise un décodeur matériel, et les navigateurs
     mobiles en accordent 4 à 8. Le reste du mur est en images fixes,
     visuellement indistinguable en périphérie.
     ══════════════════════════════════════════════════════════════════ */
  register('wall', function (root) {
    var stage = root.querySelector('.wall-stage');
    if (!stage) return;

    var COLS   = parseInt(root.dataset.cols, 10) || 21;   // emplacements sur 360°
    var ROWS   = parseInt(root.dataset.rows, 10) || 4;
    var RADIUS = parseFloat(root.dataset.radius) || 1150; // rayon du cylindre
    var ROWGAP = parseFloat(root.dataset.rowgap) || 270;
    /* Damier : une tuile sur deux reste vide. Le mur respire, et surtout
       il ne réclame que la moitié des images — un marchand qui en charge
       six doit obtenir un résultat correct, pas une grille répétitive. */
    var SPARSE = root.dataset.sparse !== 'false';
    var TILEW  = parseFloat(root.dataset.tilew) || 320;
    var TILEH  = parseFloat(root.dataset.tileh) || 235;

    /* Ces quatre valeurs se tiennent. Élargir le cylindre sans toucher
       au reste éloigne les tuiles (donc les rapetisse) ET creuse les
       écarts entre elles (donc vide le mur). Il faut donc augmenter en
       même temps le nombre d'emplacements et la taille des tuiles.
       Le nombre de colonnes suit le rayon : c'est ce qui maintient un
       écart constant entre deux tuiles voisines. */
    root.style.setProperty('--tile-w', TILEW + 'px');
    root.style.setProperty('--tile-h', TILEH + 'px');
    var media  = JSON.parse(root.dataset.media || '[]');
    if (!media.length) return;

    var vids = media.filter(function (m) { return m.type === 'video'; });
    var imgs = media.filter(function (m) { return m.type === 'image'; });

    /* Chaque tuile : rotateY(θ) puis recul de RADIUS. Le spectateur est
       au centre du cylindre, les tuiles lui font face. Celles passées
       derrière lui sont écartées par backface-visibility. */
    var playing = [];                  // les <video> réellement posées

    function build() {
      var frag = document.createDocumentFragment();
      var step = 360 / COLS;
      var midR = (ROWS - 1) / 2;
      var vi = 0, n = 0;

      /* Répartition des images. Une simple boucle séquentielle fait
         retomber le même visuel en face de lui-même d'une rangée à
         l'autre — c'est ce qui donnait l'impression de doublons.
         On décale donc chaque rangée d'un pas : deux tuiles voisines,
         de côté comme en diagonale, ne peuvent plus tirer la même.
         Le décalage vaut environ un tiers du stock, ce qui garantit
         qu'il ne retombe jamais sur un multiple du nombre d'images. */
      var shift = Math.max(2, Math.floor(imgs.length / 3));
      function pick(r, c) { return imgs[((c + r * shift) % imgs.length + imgs.length) % imgs.length]; }

      for (var r = 0; r < ROWS; r++) {
        for (var c = 0; c < COLS; c++) {
          if (SPARSE && (r + c) % 2) continue;      // un emplacement sur deux
          var angle = c * step;
          var y = (r - midR) * ROWGAP;
          // décalage d'une demi-colonne une ligne sur deux : moins de
          // grille visible, plus de désordre naturel
          if (r % 2) angle += step / 2;

          var tile = document.createElement('div');
          tile.className = 'wall-tile';
          tile.style.transform =
            'rotateY(' + angle.toFixed(2) + 'deg) translateZ(-' + RADIUS + 'px) ' +
            'translateY(' + y.toFixed(0) + 'px)';

          /* Les vidéos vont sur la rangée centrale, face au spectateur.
             Un <video> mobilise un décodeur matériel et les mobiles en
             accordent 4 à 8 : au-delà, rien ne se lance.

             Le mur de l'aperçu n'en contient plus aucune — ses trois
             vidéos ont été remplacées par leur image d'arrêt. La branche
             reste là : c'est un réglage de section, le marchand peut en
             remettre. Sans vidéo dans data-media, elle n'est jamais
             empruntée et l'observateur plus bas ne s'installe pas. */
          var el;
          var frontRow = Math.abs(r - midR) < 1;
          var frontCol = (angle < 30 || angle > 330);
          if (frontRow && frontCol && vi < vids.length) {
            el = document.createElement('video');
            el.src = vids[vi++].src;
            el.muted = true; el.loop = true; el.autoplay = true;
            el.playsInline = true; el.preload = 'metadata';
            playing.push(el);
          } else {
            el = document.createElement('img');
            el.src = pick(r, c).src;
            el.loading = n < 12 ? 'eager' : 'lazy';
            el.alt = '';
          }
          tile.appendChild(el);
          frag.appendChild(tile);
          n++;
        }
      }
      stage.appendChild(frag);
    }

    build();

    /* Un décodeur vidéo tourne même quand personne ne regarde : sorti du
       champ, le mur continuait à décoder trois flux et à les composer
       sous le reste de la page. On les met en pause dès qu'il quitte
       l'écran, on les relance quand il revient. Tout le budget d'images
       repasse alors aux sections du bas. */
    if (playing.length && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var live = entries[0].isIntersecting;
        playing.forEach(function (v) {
          if (live) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { rootMargin: '120px' }).observe(root);
    }

    /* Rotation à la souris. L'amplitude dépasse largement l'écran :
       c'est ce qui fait entrer de nouvelles tuiles en continu.

       Une souris émet jusqu'à 1000 événements par seconde, un trackpad
       120 — et l'écran n'en affiche que 60. On garde donc la dernière
       position et on n'écrit qu'une fois par image : autant de mouvement,
       dix fois moins de travail. Écrire plus souvent que l'écran ne
       rafraîchit, c'est du calcul jeté. */
    if (!reduce && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var px = 0, py = 0, pending = 0;

      function turn() {
        pending = 0;
        /* Amplitude volontairement contenue. Au-delà, on amène dans le
           champ des tuiles vues de trop biais : elles se réduisent à des
           lamelles déformées, et c'est ce qui donne l'impression que
           quelque chose cloche. On révèle quand même deux à trois
           colonnes de chaque côté, donc l'effet reste infini. */
        stage.style.setProperty('--wall-rx', (px * 62).toFixed(2));
        stage.style.setProperty('--wall-ry', (py * -14).toFixed(2));
      }

      addEventListener('pointermove', function (e) {
        px = (e.clientX / innerWidth)  - 0.5;
        py = (e.clientY / innerHeight) - 0.5;
        if (!pending) pending = requestAnimationFrame(turn);
      }, { passive: true });
    }
  });


  /* ══════════════════════════════════════════════════════════════════
     TRANSITION PIXELLISÉE
     ══════════════════════════════════════════════════════════════════
     Une grille de cellules recouvre l'écran en cascade, la page change,
     puis les cellules se retirent. Écrit de zéro, sans librairie : la
     démo d'origine tirait GSAP + 2 dépendances CDN (86 Ko) pour le même
     résultat qu'une grille CSS et des transition-delay calculés.

     Deux cas :
     · lien vers une AUTRE page → on couvre, on navigue. Au chargement
       suivant, un drapeau en sessionStorage déclenche le retrait.
     · ancre sur la MÊME page   → on couvre, on défile, on retire.
     ══════════════════════════════════════════════════════════════════ */
  var PX = (function () {
    var el = null, cells = [], busy = false;
    var FLAG = 'px-transition';        // posé seulement pour les carrés
    /* Temps mort entre le clic et le changement de page, sans rien à
       l'écran. Il ne sert pas à masquer quoi que ce soit — il sert à ce
       que le clic soit un geste et non un déclencheur. Sans lui, la page
       se remplace pendant que le doigt est encore sur le bouton, et
       l'œil enregistre une coupure au lieu d'un passage. 120 ms : c'est
       à peu près le temps qu'on met à relâcher un clic. */
    var PAUSE_MS = 120;

    function build() {
      el = document.querySelector('.px');
      if (!el) return false;
      el.style.setProperty('--px-rows', PX_ROWS);
      el.style.setProperty('--px-cols', PX_COLS);
      var frag = document.createDocumentFragment();
      for (var r = 0; r < PX_ROWS; r++) {
        for (var c = 0; c < PX_COLS; c++) {
          var cell = document.createElement('div');
          cell.className = 'px-cell';
          cell.dataset.row = r;
          frag.appendChild(cell);
          cells.push(cell);
        }
      }
      el.appendChild(frag);
      return true;
    }

    /* Le décalage dépend de la ligne, plus un peu d'aléatoire : c'est
       ce désordre qui donne l'effet de pluie plutôt qu'un balayage.
       `reverse` part du bas au lieu du haut — voir PX_REMONTE. */
    function stagger(reverse) {
      var max = 0;
      cells.forEach(function (cell) {
        var row = +cell.dataset.row;
        if (reverse) row = PX_ROWS - 1 - row;
        var d = PX_STEP * (row + Math.random() * PX_JITTER);
        cell.style.transitionDelay = d + 'ms';
        if (d > max) max = d;
      });
      return max + PX_DUR;
    }

    function cover() {
      return new Promise(function (resolve) {
        el.classList.add('is-busy');
        el.classList.remove('is-revealing', 'is-covered');
        var total = stagger(false);
        // force un reflow pour que la transition parte de scale(0)
        void el.offsetWidth;
        el.classList.add('is-covering');
        setTimeout(resolve, total);
      });
    }

    function reveal() {
      return new Promise(function (resolve) {
        el.classList.add('is-busy', 'is-covered');
        el.classList.remove('is-covering');
        void el.offsetWidth;
        var total = stagger(PX_REMONTE);
        el.classList.remove('is-covered');
        el.classList.add('is-revealing');
        setTimeout(function () {
          el.classList.remove('is-busy', 'is-revealing');
          resolve();
        }, total);
      });
    }

    function go(url, doux) {
      if (busy) return;
      busy = true;

      /* Passage discret : rien à l'écran, juste un temps mort. Aucun
         drapeau n'est posé — la page d'arrivée n'a donc aucun voile à
         retirer, elle apparaît telle quelle. */
      if (doux) { setTimeout(function () { location.href = url; }, PAUSE_MS); return; }

      cover().then(function () {
        try { sessionStorage.setItem(FLAG, 'carres'); } catch (e) {}
        location.href = url;
      });
    }

    /* Un même trajet pour tous les déplacements internes : on couvre,
       on se déplace sous le voile, on découvre. `move` est l'action de
       défilement — vers une ancre, ou vers le haut de la page. */
    function transition(move) {
      if (busy) return;
      busy = true;
      cover().then(function () {
        move();
        return reveal();
      }).then(function () { busy = false; });
    }
    function anchor(target) { transition(function () { target.scrollIntoView(); }); }
    function top()          { transition(function () { scrollTo(0, 0); }); }

    function init() {
      if (reduce || !build()) return;

      /* Arrivée derrière les carrés : on les retire. Les passages discrets
         ne posent pas de drapeau, il n'y a donc rien à faire pour eux. */
      var venu = '';
      try {
        venu = sessionStorage.getItem(FLAG) || '';
        sessionStorage.removeItem(FLAG);
      } catch (e) {}
      if (venu) reveal();
      document.documentElement.classList.remove('px-entering');

      /* Interception des clics sur les liens internes. */
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]');
        if (!a) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        if (a.target && a.target !== '_self') return;
        if (a.hasAttribute('download') || a.dataset.noTransition !== undefined) return;

        /* Carrés ou fondu ?

           La règle tient en une phrase : les carrés marquent le passage
           d'un monde à l'autre, le fondu marque le passage d'une page à
           l'autre dans le même monde.

           · boutique ⇄ compte, ou entrée dans une catégorie → carrés.
             On quitte un lieu pour un autre, l'écran doit le dire.
           · connexion → création, compte → adresses, déconnexion →
             fondu de 200 ms. On tourne une page, on ne déménage pas.
           · un volet qui s'échange dans la même page (mot de passe
             oublié) → rien du tout. Il n'y a pas eu de déplacement.

           Les liens qui traversent portent data-px, et eux seuls. C'est
           un opt-in volontaire : par défaut, un lien ne déclenche rien de
           spectaculaire. Un effet qu'on subit à chaque clic cesse d'être
           un effet et devient une attente. */
        var carres = a.dataset.px !== undefined;

        var href = a.getAttribute('href');
        if (!href || href.charAt(0) === '#') {
          var target = href && href.length > 1 && document.querySelector(href);
          /* Une ancre dans la page : on défile. Sans carrés, pas de voile
             du tout — masquer la page pour la faire glisser de 400 px
             serait un mensonge sur la distance parcourue. */
          if (target) {
            e.preventDefault();
            if (carres) anchor(target);
            else target.scrollIntoView({ behavior: 'smooth' });
          } else if (scrollY > 4) {
            e.preventDefault();
            if (carres) top();
            else scrollTo({ top: 0, behavior: 'smooth' });
          }
          return;
        }
        var url;
        try { url = new URL(a.href); } catch (err) { return; }
        if (url.origin !== location.origin) return;                 // externe
        /* On écarte mailto:, tel:, javascript:. file: est admis pour que
           l'aperçu local se comporte comme la boutique : sans lui, la
           transition ne se déclenchait jamais en double-cliquant les
           pages depuis le disque — et on croyait l'effet cassé alors
           qu'il n'était simplement jamais appelé. En ligne, tout est en
           https : la mention est sans effet. */
        if (!/^(https?|file):$/.test(url.protocol)) return;
        if (url.pathname === location.pathname && url.hash) {       // ancre same-page
          var t = document.querySelector(url.hash);
          if (t) {
            e.preventDefault();
            if (carres) anchor(t);
            else t.scrollIntoView({ behavior: 'smooth' });
            return;
          }
        }
        /* Lien vers la page déjà ouverte : on ne recharge pas, on
           remonte en haut — avec la même animation, pour que tous les
           déplacements du site se ressemblent. */
        if (url.pathname === location.pathname) {
          if (scrollY > 4) {
            e.preventDefault();
            if (carres) top();
            else scrollTo({ top: 0, behavior: 'smooth' });
          } else e.preventDefault();
          return;
        }

        e.preventDefault();
        go(a.href, !carres);
      });
    }

    return { init: init };
  })();

  document.addEventListener('DOMContentLoaded', PX.init);


  /* ══════════════════════════════════════════════════════════════════
     SECTION image-banner — parallaxe
     ══════════════════════════════════════════════════════════════════ */
  register('image-banner', function (root) {
    var bg = root.querySelector('.look-bg');
    if (!bg || reduce) return;
    /* Une image par image, pas une par événement de défilement. Un
       trackpad en tire jusqu'à 120 par seconde, et chacune lisait une
       position puis écrivait un style : le navigateur devait recalculer
       la mise en page entre les deux, plusieurs fois par image. C'est
       invisible tant que rien d'autre ne bouge — et c'est ce qui rognait
       les images pendant le vol du nom. */
    var tick = 0;
    addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        tick = 0;
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        bg.style.transform = 'translateY(' + (p * -46) + 'px)';
      });
    }, { passive: true });
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION featured-collection — vues d'un produit
     ══════════════════════════════════════════════════════════════════
     Chaque carte empile ses photos ; une seule porte .is-on. Les flèches
     font tourner la pile, en boucle : après la dernière on revient à la
     première, il n'y a donc jamais de flèche morte à griser.

     Le câblage se fait par carte et non par flèche : une carte qui n'a
     qu'une vue n'affiche aucune flèche plutôt que deux boutons inertes.
     ══════════════════════════════════════════════════════════════════ */
  register('featured-collection', function (root) {
    root.querySelectorAll('.card-media').forEach(function (media) {
      var shots = media.querySelectorAll('.card-shot');
      var prev  = media.querySelector('.card-nav.prev');
      var next  = media.querySelector('.card-nav.next');
      if (!prev || !next) return;

      if (shots.length < 2) {          // une seule vue : rien à parcourir
        prev.remove(); next.remove();
        return;
      }

      var i = 0;

      function montrer(vue) {
        shots[i].classList.remove('is-on');
        i = vue;
        shots[i].classList.add('is-on');
        /* La vue affichée cesse d'être décorative pour un lecteur
           d'écran : c'est elle qui porte désormais la description. */
        shots.forEach(function (img, rang) {
          img.setAttribute('aria-hidden', rang === i ? 'false' : 'true');
        });
      }
      function go(pas) { montrer((i + pas + shots.length) % shots.length); }

      /* Au survol, la carte passe à sa deuxième vue : on voit l'autre
         face sans rien cliquer. C'est pour ça que l'ordre des photos
         compte — la deuxième est celle qu'on montre en premier.

         En sortant, la carte revient TOUJOURS à sa première vue, même
         si on s'était arrêté sur la quatrième avec les flèches. Une
         carte qui garde la vue où on l'a laissée finit par présenter un
         lot de dos : chacune s'arrête là où le curseur est passé, et la
         rangée perd sa lecture d'ensemble. Le repos est un état, pas un
         souvenir — et c'est ce qui rend le survol suivant identique au
         premier, avec son fondu.

         Sur écran tactile il n'y a pas de survol, et un pointerenter y
         arrive avec le premier appui : sans ce test, la vue changerait
         au moment même où l'on ouvre la fiche. Les flèches y restent
         visibles en permanence (animations.css). */
      media.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        montrer(1);
      });
      media.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'touch') return;
        montrer(0);
      });

      prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
      next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    });
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION featured-product — tailles + accordéon
     ══════════════════════════════════════════════════════════════════ */
  register('featured-product', function (root) {
    root.querySelectorAll('.size:not([disabled])').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.size').forEach(function (o) {
          o.setAttribute('aria-pressed', 'false');
        });
        b.setAttribute('aria-pressed', 'true');
      });
    });

    deplier(root);
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION newsletter
     ══════════════════════════════════════════════════════════════════ */
  register('newsletter', function (root) {
    var form = root.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();                       // Liquid : soumission réelle à Shopify
      root.querySelector('.wait-ok').classList.add('on');
      form.querySelector('input').value = '';
    });
  });


  /* ══════════════════════════════════════════════════════════════════
     GLOBAL — révélations au scroll
     Mets simplement class="rv" sur un élément : il sera observé.
     ══════════════════════════════════════════════════════════════════ */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

  /* L'interrupteur vient de l'éditeur, par un attribut sur <html> : si
     le marchand a coupé les révélations, rien n'est observé du tout —
     le CSS a déjà rendu les éléments visibles. */
  var revelations = !document.documentElement.hasAttribute('data-sans-reveal');

  function observeRv(scope) {
    if (!revelations) return;
    (scope || document).querySelectorAll('.rv:not(.in)').forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', function () { observeRv(document); });
  document.addEventListener('shopify:section:load', function (e) { observeRv(e.target); });


  /* ══════════════════════════════════════════════════════════════════
     PANIER — logique partagée
     ══════════════════════════════════════════════════════════════════
     Le tiroir et la page panier montrent le MÊME panier. Deux copies du
     même calcul finiraient par diverger — un bouton corrigé d'un côté,
     oublié de l'autre — et le client verrait deux totaux différents pour
     la même commande. Il n'y a donc qu'un module, appelé deux fois.

     Le contrat est dans le HTML : chaque ligne porte data-line, sa
     quantité et son prix unitaire en centimes. Le conteneur porte les
     endroits à mettre à jour. Rien d'autre n'est supposé — c'est ce qui
     permet au tiroir et à la page d'avoir des mises en page différentes.

     ⚠️ CONVERSION LIQUID — chaque geste appellera /cart/change.js avec la
        clé de la ligne, et Shopify renverra le panier à jour. Le rendu et
        les états ci-dessous restent valables.
     ══════════════════════════════════════════════════════════════════ */
  var Panier = (function () {
    /* Les centimes, jamais les euros : 0,1 + 0,2 ne fait pas 0,3 en
       virgule flottante, et un total à 245,00000000003 € ne se rattrape
       pas. On ne divise qu'au moment d'afficher. */
    function argent() {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr',
                                   { style: 'currency', currency: 'EUR' });
    }

    function cabler(racine) {
      if (!racine || racine.__panier) return;
      racine.__panier = true;

      function maj() {
        var euros  = argent();
        var lignes = racine.querySelectorAll('[data-line]');
        var total = 0, articles = 0;

        lignes.forEach(function (l) {
          var q = parseInt(l.dataset.qty, 10) || 0;
          var p = parseInt(l.dataset.price, 10) || 0;
          total += q * p; articles += q;

          var n = l.querySelector('[data-qty-value]');
          if (n) n.textContent = q;
          var t = l.querySelector('[data-line-total]');
          if (t) t.textContent = euros.format(q * p / 100);
          /* À un exemplaire, « moins » n'a plus rien à retirer : il se
             grise plutôt que de faire disparaître la ligne par surprise.
             Pour l'enlever, il y a « Retirer », dont c'est le rôle. */
          var moins = l.querySelector('[data-qty-step="-1"]');
          if (moins) moins.disabled = (q <= 1);
        });

        var vide = lignes.length === 0;
        var msg  = racine.querySelector('.cart-empty');
        if (msg) msg.hidden = !vide;
        racine.querySelectorAll('.cart-ft, .paiement-fin, .totaux')
              .forEach(function (el) { el.hidden = vide; });

        racine.querySelectorAll('[data-cart-count]')
              .forEach(function (el) { el.textContent = articles; });
        racine.querySelectorAll('[data-cart-subtotal]')
              .forEach(function (el) { el.textContent = euros.format(total / 100); });

        /* La pastille de la barre suit, et disparaît à zéro : un panier
           vide ne s'annonce pas. */
        var pastille = document.querySelector('.hdr .cart-count');
        if (pastille) {
          pastille.textContent = articles;
          pastille.hidden = (articles === 0);
        }
      }

      /* Deux mondes, un seul geste.

         Sur la boutique, chaque ligne porte la clé Shopify de l'article
         (data-key) : on appelle /cart/change.js, et c'est la réponse du
         serveur qui fait foi. Modifier seulement l'affichage laisserait
         le vrai panier inchangé, et le client découvrirait l'écart au
         paiement.

         Dans l'aperçu, il n'y a pas de clé ni de serveur : on modifie la
         page. Même rendu, même code, source différente.

         Sans JavaScript, les commandes restent des liens vers
         /cart/change — le panier fonctionne par rechargement. */
      function envoyer(cle, quantite, ligne) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: cle, quantity: quantite })
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function (panier) {
            if (quantite === 0) { ligne.remove(); }
            else { ligne.dataset.qty = quantite; }
            /* Le serveur recalcule les prix : remises, lots, taxes. On
               reprend ses chiffres au lieu de multiplier les nôtres. */
            (panier.items || []).forEach(function (art) {
              var l = racine.querySelector('[data-key="' + art.key + '"]');
              if (!l) return;
              l.dataset.qty = art.quantity;
              l.dataset.price = art.final_price;
            });
            maj();
          })
          .catch(function () { maj(); });
      }

      racine.addEventListener('click', function (e) {
        var pas = e.target.closest('[data-qty-step]');
        var del = e.target.closest('[data-line-remove]');
        if (!pas && !del) return;

        var ligne = (pas || del).closest('[data-line]');
        if (!ligne) return;
        e.preventDefault();

        var q = parseInt(ligne.dataset.qty, 10) || 1;
        var voulue = del ? 0 : Math.max(1, q + parseInt(pas.dataset.qtyStep, 10));

        if (ligne.dataset.key && window.fetch && location.protocol !== 'file:') {
          envoyer(ligne.dataset.key, voulue, ligne);
        } else if (del) {
          ligne.remove(); maj();
        } else {
          ligne.dataset.qty = voulue; maj();
        }
      });

      racine.__majPanier = maj;
      maj();
    }

    /* Ajoute une ligne, ou incrémente celle qui existe déjà pour la même
       variante — deux lignes identiques dans un panier, c'est une erreur
       que le client corrige à la main. */
    function ajouter(racine, art) {
      if (!racine) return;
      var corps = racine.querySelector('.cart-body');
      if (!corps) return;

      var deja = [].filter.call(racine.querySelectorAll('[data-line]'), function (l) {
        return l.dataset.cle === art.cle;
      })[0];

      if (deja) {
        deja.dataset.qty = (parseInt(deja.dataset.qty, 10) || 1) + 1;
      } else {
        var l = document.createElement('div');
        l.className = 'ci';
        l.style.setProperty('--i', racine.querySelectorAll('[data-line]').length);
        l.dataset.line = ''; l.dataset.cle = art.cle;
        l.dataset.qty = '1'; l.dataset.price = art.prix;
        l.innerHTML =
          '<div class="ci-img"><img data-line-img alt="" loading="lazy" width="900" height="1200"></div>' +
          '<div><div class="ci-nm" data-line-nom></div>' +
          '<div class="ci-sp mono" data-line-variante></div>' +
          '<div class="ci-foot"><div class="qty mono">' +
            '<button type="button" data-qty-step="-1">−</button>' +
            '<span class="qty-n tnum" data-qty-value>1</span>' +
            '<button type="button" data-qty-step="1">+</button>' +
          '</div><button class="ci-del mono" type="button" data-line-remove></button></div>' +
          '<div class="ci-sp mono tnum" data-line-total style="margin-top:8px;color:var(--fg)"></div></div>';
        l.querySelector('img').src = art.photo;
        l.querySelector('.ci-nm').textContent = art.nom;
        l.querySelector('.ci-sp').textContent = art.variante;
        /* Les libellés des boutons sont copiés d'une ligne existante :
           ils sont déjà traduits, et rien n'est écrit en dur ici. */
        var modele = racine.querySelector('[data-line-remove]');
        l.querySelector('[data-line-remove]').textContent =
          modele ? modele.textContent : '';
        ['-1', '1'].forEach(function (pas) {
          var ref = racine.querySelector('[data-qty-step="' + pas + '"]');
          if (ref) l.querySelector('[data-qty-step="' + pas + '"]')
                    .setAttribute('aria-label', ref.getAttribute('aria-label') || '');
        });
        corps.appendChild(l);
      }
      if (racine.__majPanier) racine.__majPanier();
    }

    return { cabler: cabler, ajouter: ajouter };
  })();


  /* ══════════════════════════════════════════════════════════════════
     SECTION main-product — choix de la taille et ajout au panier
     ══════════════════════════════════════════════════════════════════
     Une seule taille sélectionnée à la fois : aria-pressed porte l'état,
     et il est lu par les lecteurs d'écran — une bordure noire ne dit rien
     à qui n'y voit pas.

     ⚠️ CONVERSION LIQUID — les tailles deviennent les variantes du
        produit, et l'ajout un POST sur /cart/add.js avec l'identifiant de
        la variante choisie. La sélection et le rendu ci-dessous restent.
     ══════════════════════════════════════════════════════════════════ */
  register('main-product', function (root) {
    var achat   = root.querySelector('.pdp-side--buy');
    var tailles = root.querySelectorAll('.pdp-sizes .size');
    var bouton  = root.querySelector('.btn-add');
    if (!achat) return;

    tailles.forEach(function (b) {
      if (b.disabled) return;
      b.addEventListener('click', function () {
        tailles.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
      });
    });

    deplier(root);

    /* Guide des tailles : un dépliage, pas une fenêtre. Une modale
       oblige à fermer avant de choisir ; ici le tableau s'insère au-dessus
       du bouton et la taille reste à un clic. */
    var guide = root.querySelector('.guide');
    var lien  = root.querySelector('[data-guide]');
    if (guide && lien) {
      lien.addEventListener('click', function () {
        var ouvert = guide.hidden;
        guide.hidden = !ouvert;
        lien.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      });
    }

    if (!bouton) return;

    /* ── Sur la boutique : ajout sans quitter la page ────────────────
       Le bouton vit dans un {% form 'product' %}. Laissé à lui-même, le
       navigateur envoie le formulaire et Shopify répond par la page du
       panier : on perd la fiche produit, le défilement, et l'envie
       d'ajouter autre chose. Ajouter au panier n'est pas décider
       d'acheter — c'est au visiteur de choisir quand il passe à la
       caisse.

       On intercepte donc : POST sur /cart/add.js, puis on redemande le
       tiroir au serveur (?sections=cart-drawer) et on le remplace. Les
       totaux, la devise et les traductions sont recalculés par Shopify,
       jamais reconstruits ici — les refaire en JavaScript, c'est se
       garantir un écart le jour où le marchand change de devise.

       Sans JavaScript, le formulaire part comme avant et Shopify fait le
       travail : on perd le tiroir, pas l'ajout. */
    if (bouton.form) {
      var form = bouton.form;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.__envoi) return;
        form.__envoi = true;
        bouton.setAttribute('aria-busy', 'true');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
        .then(function (r) { return r.json().then(function (d) {
          if (!r.ok) throw d; return d; }); })
        .then(function () {
          return fetch(location.pathname + '?sections=cart-drawer',
                       { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); });
        })
        .then(function (blocs) {
          var html = blocs['cart-drawer'];
          if (html) {
            var neuf = new DOMParser().parseFromString(html, 'text/html');
            var frais = neuf.querySelector('.cart');
            var vieux = document.querySelector('.cart');
            if (frais && vieux) {
              vieux.replaceWith(frais);
              /* Le tiroir est neuf : il faut le recâbler, et rappeler au
                 nombre de la barre ce qu'il vaut maintenant. */
              Panier.cabler(frais);
              var n = frais.querySelector('[data-cart-count]');
              document.querySelectorAll('.cart-count').forEach(function (b) {
                if (!n) return;
                b.textContent = n.textContent;
                b.hidden = n.textContent.trim() === '0';
              });
            }
          }
          ouvrirPanier();
        })
        .catch(function () {
          /* L'ajout a échoué — rupture de stock, variante indisponible.
             On laisse le formulaire partir normalement : Shopify affiche
             alors son propre message, qui dit la vraie raison. */
          form.submit();
        })
        .then(function () {
          form.__envoi = false;
          bouton.removeAttribute('aria-busy');
        });
      });
      return;
    }

    bouton.addEventListener('click', function () {
      var choisie = root.querySelector('.pdp-sizes .size[aria-pressed="true"]');
      var taille  = choisie ? choisie.textContent.trim() : '';
      var ref     = achat.dataset.ref || '';
      var nom     = (root.querySelector('.pdp-title') || {}).textContent || '';
      var photo   = root.querySelector('.pdp-stack img');

      var variante = (achat.dataset.txtVariante || '{t} · {ref}')
        .replace('{t}', taille).replace('{ref}', ref.trim());

      Panier.ajouter(document.querySelector('.cart'), {
        cle: nom + '|' + taille,
        nom: nom.trim(),
        variante: variante,
        prix: parseInt(achat.dataset.prix, 10) || 0,
        photo: photo ? photo.getAttribute('src') : ''
      });
    });
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION main-login — connexion ⇄ mot de passe oublié
     ══════════════════════════════════════════════════════════════════
     Les deux formulaires cohabitent dans le même gabarit, comme chez
     Shopify. On bascule sur l'ancre #recover : le lien reçu par e-mail
     et un partage d'URL retombent donc sur le bon volet, et le bouton
     Précédent du navigateur fait ce qu'on attend de lui.
     ══════════════════════════════════════════════════════════════════ */
  register('main-login', function (root) {
    var volets = root.querySelectorAll('[data-volet]');
    if (!volets.length) return;

    function montrer(nom) {
      volets.forEach(function (v) { v.hidden = v.dataset.volet !== nom; });
      var champ = root.querySelector('[data-volet="' + nom + '"] input');
      if (champ && nom !== 'login') champ.focus();
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-volet-ouvrir]')) {
        location.hash = 'recover'; montrer('recover');
      }
      if (e.target.closest('[data-volet-fermer]')) {
        history.replaceState(null, '', location.pathname);
        montrer('login');
      }
    });

    montrer(location.hash === '#recover' ? 'recover' : 'login');
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION main-addresses — formulaire d'ajout replié
     ══════════════════════════════════════════════════════════════════ */
  register('main-addresses', function (root) {

    /* Le pays est un <select> rempli par all_country_option_tags, un
       filtre Liquid qui ne sait pas présélectionner. Sans ces deux
       lignes, ouvrir une adresse pour en corriger la rue en effacerait
       le pays — et personne ne le verrait avant la livraison. */
    root.querySelectorAll('[data-country]').forEach(function (f) {
      var pays = f.querySelector('select[name="address[country]"]');
      if (pays && f.dataset.country) pays.value = f.dataset.country;
    });

    function basculer(form) {
      if (!form) return;
      form.hidden = !form.hidden;
      if (!form.hidden) {
        var premier = form.querySelector('input, select');
        if (premier) premier.focus();
      }
      return !form.hidden;
    }

    root.addEventListener('click', function (e) {
      /* Ajouter : le formulaire replié en haut de page. */
      if (e.target.closest('[data-adr-toggle]')) {
        basculer(root.querySelector('[data-adr-form]'));
        return;
      }

      /* Modifier : le formulaire de CETTE adresse, sous sa carte.
         L'état part sur le bouton qui l'a ouvert, pour que le lecteur
         d'écran sache qu'il vient de déplier quelque chose. */
      var bouton = e.target.closest('[data-adr-edit]');
      if (!bouton) return;
      var id = bouton.getAttribute('data-adr-edit');
      var ouvert = basculer(root.querySelector('#adr-form-' + id));
      root.querySelectorAll('[data-adr-edit="' + id + '"]').forEach(function (b) {
        if (b.hasAttribute('aria-expanded')) {
          b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        }
      });
    });
  });


  /* ══════════════════════════════════════════════════════════════════
     SECTION main-cart — la page panier, même logique que le tiroir
     ══════════════════════════════════════════════════════════════════ */
  register('main-cart', function (root) { Panier.cabler(root); });

  /* ══════════════════════════════════════════════════════════════════
     SECTION main-faq — questions fréquentes
     Rien d'autre à câbler : chaque question est une case dépliante.
     ══════════════════════════════════════════════════════════════════ */
  register('main-faq', function (root) { deplier(root); });


  /* ══════════════════════════════════════════════════════════════════
     GLOBAL — recherche
     ══════════════════════════════════════════════════════════════════
     La loupe déplie un panneau, on tape, les résultats apparaissent sous
     le champ. Trois principes :

     · on cherche à la frappe, sans valider. Une boutique n'est pas un
       moteur de recherche : le visiteur tape trois lettres et veut voir.
       La touche Entrée reste branchée sur /search pour la page complète ;
     · 160 ms d'attente avant de chercher. Personne ne veut de résultats
       recalculés à chaque lettre d'un mot qu'on est en train d'écrire, et
       en Liquid ce délai évitera une requête réseau par touche ;
     · l'accent ne compte pas. « veste » doit trouver « Vêtement » — sinon
       un clavier sans accent ne trouve rien, ce qui est le cas de la
       moitié des visiteurs sur téléphone.

     ⚠️ CONVERSION LIQUID — un seul point à changer : la fonction
        chercher(). Elle devient un fetch sur
        /search/suggest.json?q=…&resources[type]=product
        (recherche prédictive, exigée par le Theme Store). Tout le reste —
        ouverture, fermeture, focus, rendu — est déjà bon. Ici, faute de
        boutique, on filtre les produits présents dans la page.
     ══════════════════════════════════════════════════════════════════ */
  register('search', function (root) {
    var champ     = root.querySelector('.search-input');
    var liste     = root.querySelector('[data-search-results]');
    var compteur  = root.querySelector('.search-count');
    var declencheur = document.querySelector('[data-search-open]');
    if (!champ || !liste) return;

    /* Le catalogue de l'aperçu : on lit les cartes déjà dans la page.
       En Liquid, cette lecture disparaît au profit de l'API. */
    var catalogue = [].map.call(document.querySelectorAll('.grid .card'), function (c) {
      var img = c.querySelector('.card-shot');
      return {
        nom:   (c.querySelector('.card-name')  || {}).textContent || '',
        spec:  (c.querySelector('.card-spec')  || {}).textContent || '',
        prix:  (c.querySelector('.card-price') || {}).textContent || '',
        image: img ? img.getAttribute('src') : ''
      };
    });

    /* « Vêtement » et « vetement » doivent se valoir. normalize('NFD')
       sépare la lettre de son accent, le remplacement retire l'accent. */
    function pliable(t) {
      return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    /* Deux sources, dans cet ordre.

       Sur une boutique, on interroge la recherche prédictive de Shopify —
       c'est elle qui connaît tout le catalogue, les variantes et les
       stocks, et c'est elle que le Theme Store exige.

       Si l'appel échoue — aperçu ouvert depuis un fichier local, réseau
       coupé — on retombe sur les produits présents dans la page. Le rendu
       est le même : seule la source change. Aucune des deux ne doit être
       une condition de l'autre, sinon l'aperçu cesserait de fonctionner
       le jour où l'on retire le repli. */
    function chercher(q) {
      var local = catalogue.filter(function (p) {
        return pliable(p.nom + ' ' + p.spec).indexOf(pliable(q)) !== -1;
      });

      if (!window.fetch || location.protocol === 'file:') {
        return Promise.resolve(local);
      }

      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=8';

      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          var liste = ((d.resources || {}).results || {}).products || [];
          return liste.map(function (p) {
            return {
              nom:   p.title,
              spec:  p.vendor || '',
              prix:  p.price,
              image: p.featured_image ? p.featured_image.url : '',
              url:   p.url
            };
          });
        })
        .catch(function () { return local; });
    }

    /* Aucune phrase écrite en dur dans ce fichier.

       Une chaîne fabriquée par le JS est une chaîne que le traducteur ne
       voit jamais : elle n'existe pas encore au chargement de la page,
       donc elle reste dans la langue du développeur quoi qu'il arrive.
       C'est exactement ce qui laissait « 1 résultat » en français sur une
       page anglaise.

       Les gabarits vivent donc dans le HTML, sur l'élément .search
       (data-txt-*), là où le traducteur les atteint comme n'importe quel
       autre texte. Le JS ne fait que remplacer {n} et {q}.

       ⚠️ CONVERSION LIQUID — ces attributs deviennent
          data-txt-un="{{ 'search.one_result' | t }}" etc., alimentés par
          locales/*.json. Aucune ligne de ce fichier ne change. */
    function phrase(cle, valeurs) {
      var gabarit = root.getAttribute('data-txt-' + cle) || '';
      return gabarit.replace(/\{(\w+)\}/g, function (_, k) { return valeurs[k]; });
    }

    function rendre(res, q) {
      liste.textContent = '';
      if (!q) { compteur.textContent = ''; return; }

      compteur.textContent = res.length
        ? phrase(res.length > 1 ? 'plur' : 'un', { n: res.length })
        : phrase('vide', { q: q });

      res.forEach(function (p, i) {
        var a = document.createElement('a');
        a.className = 'search-hit';
        a.href = p.url || '#grid';
        /* Le décalage se calcule au rendu et non en CSS : la liste est
           reconstruite à chaque frappe, un :nth-child figé ne suivrait
           pas — et le nombre de résultats est inconnu à l'écriture. */
        a.style.animationDelay = Math.min(i, 6) * 45 + 'ms';
        a.innerHTML =
          '<span class="shot"><img src="' + p.image + '" alt="" loading="lazy"></span>' +
          '<b></b><span class="mono"></span><span class="mono tnum"></span>';
        a.querySelector('b').textContent = p.nom;
        a.querySelectorAll('span.mono')[0].textContent = p.spec;
        a.querySelectorAll('span.mono')[1].textContent = p.prix;
        liste.appendChild(a);
      });
    }

    var minuteur = 0, jeton = 0;
    champ.addEventListener('input', function () {
      clearTimeout(minuteur);
      var q = champ.value.trim();
      minuteur = setTimeout(function () {
        /* Un jeton par recherche : deux réponses réseau peuvent revenir
           dans le désordre, et la plus lente écraserait la plus récente.
           On n'affiche que celle de la dernière frappe. */
        var mien = ++jeton;
        Promise.resolve(chercher(q)).then(function (res) {
          if (mien === jeton) rendre(res, q);
        });
      }, 160);
    });

    function ouvrir() {
      document.body.classList.add('search-open');
      root.setAttribute('aria-hidden', 'false');
      if (declencheur) declencheur.setAttribute('aria-expanded', 'true');
      /* Le focus attend la fin du dépliement : le donner tout de suite
         ferait remonter la page sur un champ encore rogné. */
      setTimeout(function () { champ.focus(); }, 120);
    }

    function fermer() {
      if (!document.body.classList.contains('search-open')) return;
      document.body.classList.remove('search-open');
      root.setAttribute('aria-hidden', 'true');
      if (declencheur) {
        declencheur.setAttribute('aria-expanded', 'false');
        declencheur.focus();          // le focus revient d'où il venait
      }
      champ.value = ''; rendre([], '');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]'))  { e.preventDefault(); ouvrir(); }
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); fermer(); }
      /* Un clic sur le voile, sous le panneau, rend la page — même geste
         que pour le menu. On vise le voile lui-même et pas un descendant :
         il n'en a aucun, mais closest() protège d'un futur enfant. */
      if (e.target.closest('.panel-bg')) fermer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });

    /* Ouvrir le menu ferme la recherche, et réciproquement : deux
       panneaux qui descendent du même bord ne peuvent pas cohabiter. */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-toggle]')) fermer();
    });
  });


  /* ══════════════════════════════════════════════════════════════════
     GLOBAL — panier (snippet, présent une seule fois)
     ══════════════════════════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    /* Le tiroir est REMPLACÉ après chaque ajout (le serveur le renvoie à
       jour) : on ne peut donc pas garder son nœud dans une variable, il
       serait périmé au premier ajout. On le redemande à chaque geste. */
    function tiroir() { return document.querySelector('.cart'); }
    var scrim = document.querySelector('.scrim');
    if (!tiroir()) return;

    /* Verrouiller le défilement sans faire sauter la page : on mesure la
       largeur réelle de la barre de défilement — la différence entre la
       fenêtre et la zone utile — et on la rend à la page en marge. Voir
       le commentaire de body.is-locked dans base.css. */
    function verrouiller(oui) {
      var barre = oui ? innerWidth - document.documentElement.clientWidth : 0;
      document.documentElement.style.setProperty('--sb', barre + 'px');
      document.body.classList.toggle('is-locked', oui);
    }

    function openCart() {
      var cart = tiroir();
      if (!cart) return;
      cart.classList.add('on'); scrim.classList.add('on');
      cart.setAttribute('aria-hidden', 'false');
      verrouiller(true);
      var fermer = cart.querySelector('[data-cart-close]');
      if (fermer) fermer.focus();
    }
    function closeCart() {
      var cart = tiroir();
      if (!cart) return;
      cart.classList.remove('on'); scrim.classList.remove('on');
      cart.setAttribute('aria-hidden', 'true');
      verrouiller(false);
    }

    /* Ouvrir le tiroir depuis ailleurs — après un ajout, par exemple.
       Une fonction plutôt qu'un clic simulé : un clic passerait par la
       délégation et dépendrait d'un bouton présent dans la page. */
    ouvrirPanier = openCart;

    // délégation : fonctionne aussi pour les boutons ajoutés plus tard
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]'))  openCart();
      if (e.target.closest('[data-cart-close]')) closeCart();
      /* Un clic hors du tiroir, sur le voile, referme — même geste que
         pour le menu et la recherche. closest() plutôt qu'une égalité
         stricte : le voile pourrait un jour contenir quelque chose. */
      if (e.target.closest('.scrim')) closeCart();

    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    Panier.cabler(tiroir());
  });


  /* ══════════════════════════════════════════════════════════════════
     GLOBAL — curseur personnalisé
     ══════════════════════════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    var cur = document.querySelector('.cursor');
    if (!cur || reduce) return;
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    /* Le curseur est en mix-blend-mode: difference — il ne peut donc pas
       être composité seul : chaque déplacement force un repeint de la
       zone qu'il recouvre, mur vidéo compris. À 1000 événements par
       seconde, c'est le poste le plus cher de la page. Une écriture par
       image suffit : l'œil n'en verra jamais davantage.

       translate3d plutôt que translate : la version 3D demande
       explicitement un calque, ce qui évite au navigateur de reconstruire
       le rendu du curseur à chaque image. */
    var cx = 0, cy = 0, queued = 0;

    function move() {
      queued = 0;
      cur.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)';
    }

    addEventListener('pointermove', function (e) {
      cur.classList.add('is-on');
      cx = e.clientX; cy = e.clientY;
      if (!queued) queued = requestAnimationFrame(move);
    }, { passive: true });
    document.addEventListener('pointerover', function (e) {
      cur.classList.toggle('is-big', !!e.target.closest('a, button, .card'));
    });
  });

})();
